import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../../services/user-management.service';
import { UserDetails } from '../../models/auth';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  userName?: string;
  userEmail?: string;
  userRole?: string;
  firstName?: string;
  orgName?: string;
  isDropdownOpen = false;
  isLoading: boolean = false;

  constructor(
    private userManagementService: UserManagementService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    const userDetails: UserDetails = this.userManagementService.userDetails;
    this.userRole = this.userManagementService.userRole;

    const { name, email, given_name } = userDetails;

    this.userName = name;
    this.userEmail = email;
    this.firstName = given_name;

    this.orgName = this.userManagementService.getOrgName();
  }

  dropdownToggle(visible: boolean): void {
    this.isDropdownOpen = visible;
  }

  async signOut() {
    this.isLoading = true;
    await this.authService.logout();
  }
}
